import React, { FunctionComponent } from 'react'

import { Box, BoxProps } from '@theme-ui/components'

export const Separator: FunctionComponent<BoxProps> = ({ sx, ...rest }) => (
  <Box sx={{ bg: 'grey200', height: 1, mt: 8, mb: 6, ...sx }} {...rest} />
)
